//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettingFormModal from "@/modules/setting/components/setting-form-modal.vue";
import PackagesFormModal from "@/modules/setting/components/packages-form-modal.vue";
import i18n from "@/vueI18n";
import { mapGetters } from "vuex";

export default {
  name: "app-setting-list-card",
  props: ["title", "formTitle", "message", "entity"],
  components: {
    [SettingFormModal.name]: SettingFormModal,
    [PackagesFormModal.name]: PackagesFormModal,
  },
  data() {
    return {
      modalVisible: false,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      packages: "setting/list/packages",
    }),
    isRTL() {
      // return getLanguageCode() == 'ar'
      // return localStorage.getItem('language') == 'ar'
      return i18n.locale == "ar";
    },
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
    onModalOpen() {
      setTimeout(() => {
        this.modalVisible = true;
        this.dialogVisible = true;
      }, 100);
    },
    onModalClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.modalVisible = false;
      }, 500);
      //  setTimeout(() => {

      // }, 500);
    },
    onModalSuccess() {
      this.onModalClose();
      this.$emit("openSuccess");
      // Reload packages data after successful update
      if (this.entity === "packages") {
        this.$store.dispatch("setting/list/loadPackages");
      }
    },
  },

  async mounted() {
    // Load packages data when component mounts
    if (this.entity === "packages") {
      await this.$store.dispatch("setting/list/loadPackages");
    }
  },
};
